export function CzkIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1393_9482)">
        <path
          d="M12.0059 24C18.6333 24 24.0059 18.6274 24.0059 12C24.0059 5.37258 18.6333 0 12.0059 0C5.37844 0 0.00585938 5.37258 0.00585938 12C0.00585938 18.6274 5.37844 24 12.0059 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M10.9623 12C10.9623 12 3.52754 20.487 3.52051 20.4853C5.69204 22.6568 8.69209 24 12.0058 24C18.6332 24 24.0058 18.6274 24.0058 12H10.9623Z"
          fill="#D80027"
        />
        <path
          d="M3.52057 3.51465C-1.16571 8.20093 -1.16571 15.7989 3.52057 20.4853C5.45712 18.5487 7.3196 16.6862 12.0059 12L3.52057 3.51465Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_1393_9482">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.00585938)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
